/**
 * The chemical resistance enum (available in @igus/material-data):
 * '+' - resistant,
 * '-' - not resistant,
 * 'o' - partly resistant,
 * '4' - resistant, but swelling is possible (swelling, softening through water),
 * 'x' - no data exists
 */
var ChemicalResistance;
(function (ChemicalResistance) {
  /**
   * Resistant
   */
  ChemicalResistance["resistant"] = "+";
  /**
   * Not resistant
   */
  ChemicalResistance["notResistant"] = "-";
  /**
   * Partly resistant
   */
  ChemicalResistance["partlyResistant"] = "o";
  /**
   * Resistant, but swelling is possible (swelling, softening through water)
   */
  ChemicalResistance["resistantButSwelling"] = "4";
  /**
   * No data exists
   */
  ChemicalResistance["noData"] = "x";
})(ChemicalResistance || (ChemicalResistance = {}));

/**
 * The material color
 */
var Color;
(function (Color) {
  /* eslint-disable @typescript-eslint/naming-convention */
  Color["ANTHRACITE"] = "ANTHRACITE";
  Color["BEIGE"] = "BEIGE";
  Color["BEIGE_BROWN"] = "BEIGE_BROWN";
  Color["BLACK"] = "BLACK";
  Color["BLUE"] = "BLUE";
  Color["BROWN"] = "BROWN";
  Color["CREME_WHITE"] = "CREME_WHITE";
  Color["DARK_BLUE"] = "DARK_BLUE";
  Color["DARK_GREY"] = "DARK_GREY";
  Color["DARK_RED"] = "DARK_RED";
  Color["DULL_GREY"] = "DULL_GREY";
  Color["GREEN"] = "GREEN";
  Color["GREY"] = "GREY";
  Color["LIGHT_BEIGE"] = "LIGHT_BEIGE";
  Color["LIGHT_YELLOW"] = "LIGHT_YELLOW";
  Color["MAGENTA"] = "MAGENTA";
  Color["WHITE"] = "WHITE";
  Color["WHITISH"] = "WHITISH";
  Color["YELLOW"] = "YELLOW";
  Color["YELLOW_BEIGE"] = "YELLOW_BEIGE";
  /* eslint-enable @typescript-eslint/naming-convention */
})(Color || (Color = {}));

/**
 * The material schema version updated each time the material contract is changed
 */
const materialSchemaVersion = '4.2.0';

/**
 * The procedure used to print the material
 */
var Procedure;
(function (Procedure) {
  /* eslint-disable @typescript-eslint/naming-convention */
  Procedure["SLS"] = "SLS";
  Procedure["FDM"] = "FDM";
  Procedure["IM"] = "IM";
  Procedure["DLP"] = "DLP";
  Procedure["CNC"] = "CNC";
  Procedure["COATING"] = "COATING";
  Procedure["WOUND"] = "WOUND";
  /* eslint-enable @typescript-eslint/naming-convention */
})(Procedure || (Procedure = {}));

export { ChemicalResistance, Color, Procedure, materialSchemaVersion };
